module.exports = __webpack_public_path__ + "media/components/src/assets/images/line_2-3294eca5a231db2475981af052583d5d.jpg";